import { Component } from '@angular/core';

@Component({
  selector: 'app-crm-custom-page3',
  templateUrl: './crm-custom-page3.component.html',
  styleUrls: ['./crm-custom-page3.component.css']
})
export class CrmCustomPage3Component {

}
